export function generateUUID() {
    if (self && self.crypto && typeof self.crypto.randomUUID === 'function') {
        return self.crypto.randomUUID();
    }
    return 'player-' + Math.random().toString(36).slice(-8);
}

export function normalizeString(str: string) {
    return str.replace(/\s+/g, '').toLowerCase();
}

const CONTENT_SOURCES = [
    'Capi',
    'Curate',
    'ElasticSearch',
    'Editorial',
    'Stream',
    'Other',
] as const;

export type ContentSource = (typeof CONTENT_SOURCES)[number];

export function normalizeContentSource(contentSource: string): ContentSource {
    const match = CONTENT_SOURCES.find(
        (source) => source.toLowerCase() === contentSource.toLowerCase(),
    );
    return match ?? 'Other';
}
